// Dynamic locale helper.
// Instead of declaring a hardcoded list of languages, we dynamically match locale pattern (e.g. 'en', 'ja', 'zh-CN')
// to allow the system to scale and support new languages automatically.
export const isLocale = (segment: string | undefined | null): boolean => {
    if (!segment) return false;
    const lower = segment.toLowerCase();
    
    // Exclude system names and assets
    const systemExcludes = ['ui', 'api', 'js', 'css', 'go', 'to', 'in', 'on', 'at', 'id'];
    if (systemExcludes.includes(lower)) return false;
    
    // Pattern for locale code (e.g., 'en', 'vi', 'zh-CN', 'en-US')
    return /^[a-z]{2}([-_][a-zA-Z]{2,4})?$/.test(lower);
};
